import { RibbonGroupBase } from '../ribbon-interfaces';
// Constants for UI element IDs
export const PROTECT_GROUP = '_protect_group';
export const PROTECT_DOCUMENT_ID = '_protect_document';
export const READ_ONLY_ID = '_read_only';
export const RESTRICT_EDITING_ID = '_restrict_editing';
/**
 * Represents the Protect Group in Review
 * @private
 */
export class ProtectGroup extends RibbonGroupBase {
    /**
     * Constructor for the ProtectGroup
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        super(container);
    }
    /**
     * Gets the ribbon group model for Protect
     * @returns {RibbonGroupModel} The ribbon group model
     */
    getGroupModel() {
        const locale = this.localObj;
        // Create items for the protect document dropdown
        const protectItems = [
            {
                id: this.ribbonId + PROTECT_DOCUMENT_ID + '_readonly',
                text: locale.getConstant('Read Only'),
                iconCss: 'e-icons e-de-read-only'
            },
            {
                id: this.ribbonId + PROTECT_DOCUMENT_ID + '_restrict',
                text: locale.getConstant('Restrict Editing'),
                iconCss: 'e-icons e-de-restrict-edit'
            }
        ];
        return {
            id: this.ribbonId + PROTECT_GROUP,
            header: locale.getConstant('Protect'),
            orientation: 'Rows',
            keyTip: 'ZR',
            enableGroupOverflow: true,
            overflowHeader: locale.getConstant('Protect'),
            collections: [
                {
                    items: [
                        {
                            id: this.ribbonId + PROTECT_DOCUMENT_ID,
                            type: 'DropDown',
                            dropDownSettings: {
                                content: locale.getConstant('Protect Document'),
                                items: protectItems,
                                iconCss: 'e-icons e-de-ctnr-lock',
                                select: this.protectDocumentDropdownHandler.bind(this),
                                beforeItemRender: this.onBeforeRenderProtectDropdown.bind(this)
                            },
                            ribbonTooltipSettings: {
                                title: locale.getConstant('Protect Document'),
                                content: locale.getConstant('Control what types of changes can be made to the document')
                            }
                        }
                    ]
                }
            ]
        };
    }
    /**
     * Handle selection in protect document dropdown
     * @param {MenuEventArgs} args - Menu event arguments
     * @returns {void}
     */
    protectDocumentDropdownHandler(args) {
        const id = args.item.id;
        if (args.item && id) {
            if (id === this.ribbonId + PROTECT_DOCUMENT_ID + '_readonly') {
                // Toggle read-only mode
                this.container.restrictEditing = !this.container.restrictEditing;
                this.updateReadOnlyIcon(args.element);
            }
            else if (id === this.ribbonId + PROTECT_DOCUMENT_ID + '_restrict') {
                // Show restrict editing dialog
                this.documentEditor.documentHelper.restrictEditingPane.showHideRestrictPane(true);
            }
        }
    }
    /**
     * Handle rendering of protection dropdown items to show current state
     * @param {MenuEventArgs} args - Menu event arguments
     * @returns {void}
     */
    onBeforeRenderProtectDropdown(args) {
        const selectedIcon = args.element.getElementsByClassName('e-menu-icon')[0];
        if (!selectedIcon) {
            return;
        }
        if (args.item.id === this.ribbonId + PROTECT_DOCUMENT_ID + '_readonly') {
            this.toggleSelectedIcon(selectedIcon, this.documentEditor.isReadOnly);
        }
        else if (args.item.id === this.ribbonId + PROTECT_DOCUMENT_ID + '_restrict') {
            const restrictPane = document.getElementsByClassName('e-de-restrict-pane')[0];
            if (restrictPane) {
                const isRestrictPaneVisible = !(restrictPane.style.display === 'none');
                this.toggleSelectedIcon(selectedIcon, isRestrictPaneVisible);
            }
        }
    }
    /**
     * Updates the read-only icon in the dropdown item
     * @param {HTMLElement} menuElement - The menu element
     * @returns {void}
     */
    updateReadOnlyIcon(menuElement) {
        const selectedIcon = menuElement.getElementsByClassName('e-menu-icon')[0];
        if (selectedIcon) {
            this.toggleSelectedIcon(selectedIcon, this.documentEditor.isReadOnly);
        }
    }
    /**
     * Toggles the selected icon state
     * @param {HTMLElement} icon - The icon element
     * @param {boolean} isSelected - Whether the item is selected
     * @returns {void}
     */
    toggleSelectedIcon(icon, isSelected) {
        if (isSelected) {
            icon.classList.add('e-de-selected-item');
        }
        else {
            icon.classList.remove('e-de-selected-item');
        }
    }
    /**
     * Update UI based on document protection state
     * @returns {void}
     */
    updateSelection() {
        // Update UI to reflect current document protection state if needed
        const isReadOnly = this.documentEditor.isReadOnly;
        // Update read-only button state if it exists in the UI
        const readOnlyElement = document.getElementById(this.ribbonId + READ_ONLY_ID);
        if (readOnlyElement) {
            readOnlyElement.classList.toggle('e-active', isReadOnly);
        }
    }
}
